
import React from 'react';
import InfoCard from '@/components/ui/InfoCard';

const AdRequestInfoCards: React.FC = () => {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <InfoCard
        title="Processus simplifié"
        message="Remplissez le formulaire en quelques clics et notre équipe vous contactera rapidement."
        icon="⚡"
        colorScheme="bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200"
      />
      
      <InfoCard
        title="Support personnalisé"
        message="Recevez des offres d'annonces adaptées à vos besoins et votre budget."
        icon="🎯"
        colorScheme="bg-gradient-to-r from-purple-50 to-pink-50 border-purple-200"
      />
    </div>
  );
};

export default AdRequestInfoCards;
